import { Typography } from '@mui/material'

import PlainHeader from '@ecm/ui/component/block/PlainHeader'
import Anchor from '@ecm/ui/element/Anchor'
import MainContainer from '@ecm/ui/element/MainContainer'
import DefaultLayout from '@ecm/ui/layout/Default'

const CareersPage = () => (
  <DefaultLayout hideFinalCta seoPage="company/careers">
    <PlainHeader title="We're all in this together" />
    <MainContainer sx={{ py: '3em' }}>
      <Typography variant="h3" component="h2">
        Who We Are
      </Typography>
      <Typography variant="p3">
        We believe you shouldn’t have to go to your mailbox to get your mail. We help take the
        frustration out of postal mail by digitizing it for our customers. This gives them the power
        to access their postal mail 24/7, on any device.
      </Typography>

      <Typography variant="p3">
        Established in 2004, Earth Class Mail serves thousands of customers, including individuals,
        families, and even some of the nation’s top companies. To date, our services have helped
        digitize millions of pieces of postal mail and deposit billions of dollars for our
        customers. In 2021, we joined{' '}
        <Anchor href="https://www.legalzoom.com/" variant="p4" external>
          LegalZoom
        </Anchor>
        , the No. 1 choice for helping start, run, and grow small businesses.*
      </Typography>

      <Typography variant="h3" component="h2">
        Want to join our team?
      </Typography>
      <Typography variant="p3">
        Visit the{' '}
        <Anchor href="https://www.legalzoom.com/careers" variant="p4" external>
          LegalZoom Careers Page
        </Anchor>{' '}
        to see our{' '}
        <Anchor href="https://www.legalzoom.com/careers#open-positions" variant="p4" external>
          current openings
        </Anchor>
        .
      </Typography>
      <Typography variant="p4" component="p" mt="2em">
        *Based on a January 2023 survey of small- and midsize-business owners comparing LegalZoom to
        other online legal services companies.
      </Typography>
    </MainContainer>
  </DefaultLayout>
)

export default CareersPage
